import {Injectable} from '@angular/core';
import {CookieService} from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  constructor(private cookieService: CookieService) {
    if (this.getDeviceId() === null) {
      const deviceId = this.makeDeviceId();
      this.cookieService.set('deviceId', deviceId);
    }
  }

  private makeDeviceId() {
    const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const deviceId = [];
    for (let index = 32; index; index--) {
      deviceId.push(alphabet[Math.floor(Math.random() * 62)]);
    }
    return deviceId.join('');
  }

  public getDeviceId() {
    return this.cookieService.get('deviceId');
  }

  public getCookie(key: string, prefix: string) {
    const fullKey = prefix + key;
    return this.cookieService.get(fullKey);
  }

  public get(key: string, prefix: string) {
    const fullKey = prefix + key;
    return localStorage.getItem(fullKey);
  }

  public storeCookie(value: string, key: string, prefix: string) {
    const fullKey = prefix + key;
    if (value !== null && typeof value !== 'undefined') {
      this.cookieService.set(fullKey, value);
    } else {
      this.cookieService.delete(fullKey);
    }
    return this;
  }

  public store(value: string, key: string, prefix: string) {
    const fullKey = prefix + key;
    if (value !== null && typeof value !== 'undefined') {
      localStorage.setItem(fullKey, value);
    } else {
      localStorage.removeItem(fullKey);
    }
    return this;
  }

  public remove(key: string, prefix: string) {
    const fullKey = prefix + key;
    localStorage.removeItem(fullKey);
    return this;
  }

  public removeStorage(key: string, prefix: string) {
    const fullKey = prefix + key;
    this.cookieService.delete(fullKey);
    return this;
  }
}
